import type { ReactNode } from 'react'
import { fetchPageMeta } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import ContactPage from '#src/pages/contact/ContactPage.js'
import { getContactPageData } from '#src/pages/contact/contactPageData.js'
import { mergeMeta } from '#src/seo.js'
import type { Route } from './+types/contact.route.js'

// mudstudios.com/contact (+ /sv/kontakt, mounted in routes.ts)

export async function loader({ request }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const [data, meta] = await Promise.all([
    getContactPageData(lang),
    fetchPageMeta('contactPage', lang, '/contact'),
  ])
  return { data, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function Contact({ loaderData }: Route.ComponentProps): ReactNode {
  return <ContactPage data={loaderData.data} />
}
